export const printQueueMaintenanceRequiredFieldList: string[] = [
    'printQueue',
];

export const PrintQueueMaintenanceConstant = {
    CATEGORY: "Support",
    TITLE: "Print Queue",
    PRINT_QUEUE: "Print Queue",
    PRINT_QUEUE_NAME: "Print Queue Name",
    PRINT_QUEUE_DESC: "Print Queue Desc.",
    SEQUENTIAL_PRINTING_ENABLED: "Sequential Printing Enabled",
    ACTIVE_IND: "Active Ind.",

}
